import script from "./Generali.vue?vue&type=script&setup=true&lang=js"
export * from "./Generali.vue?vue&type=script&setup=true&lang=js"

import "./Generali.vue?vue&type=style&index=0&id=36b6136c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b6136c"]])

export default __exports__